var map = {
	"./10_of_clubs.png": 3724,
	"./10_of_diamonds.png": 688,
	"./10_of_hearts.png": 7351,
	"./10_of_spades.png": 5696,
	"./2_of_clubs.png": 6441,
	"./2_of_diamonds.png": 5274,
	"./2_of_hearts.png": 3544,
	"./2_of_spades.png": 9278,
	"./3_of_clubs.png": 301,
	"./3_of_diamonds.png": 7707,
	"./3_of_hearts.png": 2079,
	"./3_of_spades.png": 2346,
	"./4_of_clubs.png": 1751,
	"./4_of_diamonds.png": 377,
	"./4_of_hearts.png": 5900,
	"./4_of_spades.png": 3985,
	"./5_of_clubs.png": 9186,
	"./5_of_diamonds.png": 472,
	"./5_of_hearts.png": 2806,
	"./5_of_spades.png": 8415,
	"./6_of_clubs.png": 1636,
	"./6_of_diamonds.png": 5098,
	"./6_of_hearts.png": 5004,
	"./6_of_spades.png": 9752,
	"./7_of_clubs.png": 9943,
	"./7_of_diamonds.png": 7193,
	"./7_of_hearts.png": 367,
	"./7_of_spades.png": 8629,
	"./8_of_clubs.png": 9704,
	"./8_of_diamonds.png": 2251,
	"./8_of_hearts.png": 2324,
	"./8_of_spades.png": 3399,
	"./9_of_clubs.png": 567,
	"./9_of_diamonds.png": 8663,
	"./9_of_hearts.png": 8766,
	"./9_of_spades.png": 4355,
	"./ace_of_clubs.png": 6729,
	"./ace_of_diamonds.png": 9169,
	"./ace_of_hearts.png": 6538,
	"./ace_of_spades.png": 6696,
	"./ace_of_spades2.png": 8635,
	"./back_card.jpeg": 4180,
	"./black_joker.png": 5670,
	"./jack_of_clubs.png": 8107,
	"./jack_of_clubs2.png": 8131,
	"./jack_of_diamonds.png": 517,
	"./jack_of_diamonds2.png": 2033,
	"./jack_of_hearts.png": 8276,
	"./jack_of_hearts2.png": 153,
	"./jack_of_spades.png": 8073,
	"./jack_of_spades2.png": 9775,
	"./king_of_clubs.png": 3654,
	"./king_of_clubs2.png": 7995,
	"./king_of_diamonds.png": 8870,
	"./king_of_diamonds2.png": 5824,
	"./king_of_hearts.png": 5285,
	"./king_of_hearts2.png": 964,
	"./king_of_spades.png": 2767,
	"./king_of_spades2.png": 6500,
	"./queen_of_clubs.png": 784,
	"./queen_of_clubs2.png": 5588,
	"./queen_of_diamonds.png": 9720,
	"./queen_of_diamonds2.png": 5620,
	"./queen_of_hearts.png": 3900,
	"./queen_of_hearts2.png": 553,
	"./queen_of_spades.png": 2044,
	"./queen_of_spades2.png": 4596,
	"./red_joker.png": 6888
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3646;